export class ShiftTime {
    public date: Date;
    public start: Date;
    public end: Date;
}
